var StudyTypes = /* @__PURE__ */ ((StudyTypes2) => {
  StudyTypes2["RolloutTarget"] = "RolloutTarget";
  StudyTypes2["FeatureRollout"] = "FeatureRollout";
  return StudyTypes2;
})(StudyTypes || {});
var TreatmentVariableExperienceType = /* @__PURE__ */ ((TreatmentVariableExperienceType2) => {
  TreatmentVariableExperienceType2["IncludeTreatmentRow"] = "IncludeTreatmentRow";
  TreatmentVariableExperienceType2["IncludeRowAlways"] = "IncludeRowAlways";
  TreatmentVariableExperienceType2["DefinitionRequired"] = "DefinitionRequired";
  return TreatmentVariableExperienceType2;
})(TreatmentVariableExperienceType || {});
export {
  StudyTypes,
  TreatmentVariableExperienceType
};
//# sourceMappingURL=MasterDataModel.js.map
